import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function UnauthorizedPage() {
  const { user, isAuthorized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthorized) {
      navigate('/');
    }
  }, [isAuthorized, navigate]);

  if (isAuthorized) {
    return null;
  }

  return (
    <div className="page-container">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          BETHANY SOLO MULTIMEDIA TEAM
        </h1>
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-red-800 mb-4">
            Unauthorized Access
          </h2>
          <p className="text-red-700">
            Your account ({user?.email}) is not authorized. Please contact david@bethanysolo.or.id for authorization.
          </p>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedPage;